import IListResponse from '../../utils/list-response';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

export interface IAppointmentPaymentReport {
  appointmentId: string;
  authorizedAt?: string;
  code: number;
  billingUserName: string;
  finishAt?: string;
  paymentStatus: string;
  nsu: string;
  authorizationCode: string;
  brand: string;
  paymentType: string;
  productId: string;
  productName: string;
  price: number;
  quantity: number;
  startAt?: string;
  costCenter: string;
  productCode: string;
  productType: string;
  productNature: string;
  invoiceType: string;
}

export type IAppointmentPaymentReportsList =
  IListResponse<IAppointmentPaymentReport>;

interface IListAppointmentPaymentReportsProps {
  authorizationDateEnd: Date;
  authorizationDateInit: Date;
  limit?: number;
  order?: 'ASC' | 'DESC';
  page?: number;
  sort?: 'createdAt';
}

export const listAppointmentPaymentReportsService = async ({
  authorizationDateEnd,
  authorizationDateInit,
  limit,
  order,
  page,
  sort,
}: IListAppointmentPaymentReportsProps): Promise<IAppointmentPaymentReportsList> => {
  const { data } = await jhsfBookingsApi.get<IAppointmentPaymentReportsList>(
    '/appointments/payments/reports',
    {
      params: {
        authorizationDateEnd,
        authorizationDateInit,
        limit,
        order,
        page,
        sort,
      },
    },
  );

  return data;
};
